export const DASHBOARD_CARD_TOOLTIPS: Record<string, string> = {
  messages: 'The number of messages sent by all users during the selected time period.',
  topics: 'The top 5 SDG keywords associated with all messages sent by users during the selected time period.',
  questionRelevance: 'The ratio of all SDG-related messages to the total number of messages within the selected time period.',
  activeUsers: 'Ranking of users who sent the most messages during the selected time period.',
  topTopics: 'The top 5 SDG keywords associated with all messages sent by users during the selected time period.',
  disciplines: 'The top 5 Disciplines words associated with all messages sent by users during the selected time period.',
  industries: 'The top 5 Industries words associated with all messages sent by users during the selected time period.',
  wordCloud: 'All SDG keywords associated with all messages sent by users during the selected time period.',
  relevanceDistribution: 'Relevance Distribution',
  zeroRelevance: 'Zero-Relevance Questions',
  webSearch: 'Web-Search Questions',
};

export const GENERAL_RATE_TOOLTIPS: Record<string, string> = {
  'Avg. Relevance': 'The ratio of all SDG-related messages to the total number of messages within the selected time period.',
  'Coverage': 'The ratio of messages retrievable from SDG internal database relative to all SDG-related messages within the selected time period.',
  'Irrelevant': 'The Number of SDG-unrelated messages within the selected time period.',
  'Web Search': 'The number of messages retrieved via web search within the selected time period.',
};

export const QUESTION_ANALYSIS_TOOLTIPS: Record<string, string> = {
  relevanceDistribution: 'The number of messages which is related in SDGs sent by all users during the selected time period.',
  zeroRelevance: 'Questions that were classified as unrelated to SDGs.',
  webSearch: 'Questions that required the web-search pipeline to answer.',
};
